import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoginComponent} from './components/login/login.component';
import {SelectComponent} from './components/selects/select/select.component';
import {PedidoGeneradoComponent} from './components/comprobante/pedido-generado.component';
import {PageerrorComponent} from './components/pageerror/pageerror.component';
import {UserComponent} from './components/user/user.component';
import {SelectBindingComponent} from './components/selects/select-binding/select-binding.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {MaterialModule} from './modules/material/material.module';
import {MDBBootstrapModule} from 'angular-bootstrap-md/index';
import {FormService} from './services/formServices';
import {Angular5DataTableModule} from './modules/angular5-data-table/angular5-data-table.module';
import { SelectStateComponent } from './components/selects/modificar/select-state/select-state.component';
import { ObservacionesTecnicoComponent } from './components/form/observaciones-tecnico/observaciones-tecnico.component';
import { SelectExecutorComponent } from './components/modals/select-executor/select-executor.component';
import {SelectBindingModifComponent} from './components/selects/modificar/select-binding/select-binding.component';
import { ObservacionesCategoriasComponent } from './components/form/observaciones-categorias/observaciones-categorias.component';
import { ModalPedidoComponent } from './components/modals/pedido/pedido.component';
import { StateComponent } from './components/text/state/state.component';
import { ToastrComponent } from './components/toastr/toastr.component';
import { UploadFileComponent } from './components/filesDialog/dialog/dialog.component';
import { FilesService } from './services/files.service';
import { AddFilesComponent } from './components/modals/files/files.component';
import { SingleoptionSinBindingComponent } from './components/selects/singleoption/singleoption.component';
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import { MultioptionComponent } from './components/selects/multioption/multioption.component';
import { GuiaComponent } from './components/guia/guia.component';
import { SolicitudinformacionComponent } from './components/form/solicitudinformacion/solicitudinformacion.component';
import { FormCargadoComponent } from './components/form/form-cargado/form-cargado.component';
@NgModule({
  imports: [
CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MDBBootstrapModule.forRoot(),
      NgMultiSelectDropDownModule.forRoot(),
      HttpClientModule,
      MaterialModule,
      Angular5DataTableModule
  ],
  exports: [
      SelectComponent,
      LoginComponent,
      PageerrorComponent,
      SelectBindingComponent,
      PedidoGeneradoComponent,
      UserComponent,
      ObservacionesTecnicoComponent,
      SelectExecutorComponent,
      SelectStateComponent,
      SelectBindingModifComponent,
      ObservacionesCategoriasComponent,
      ModalPedidoComponent,
      StateComponent,
      ToastrComponent,
      UploadFileComponent,
      AddFilesComponent,
      SingleoptionSinBindingComponent,
      MultioptionComponent,
      GuiaComponent,
      SolicitudinformacionComponent,
      FormCargadoComponent
  ],
  declarations: [
      SelectComponent,
      LoginComponent,
      PageerrorComponent,
      SelectBindingComponent,
      PedidoGeneradoComponent,
      UserComponent,
      SelectStateComponent,
      ObservacionesTecnicoComponent,
      SelectExecutorComponent,
      SelectBindingModifComponent,
      ObservacionesCategoriasComponent,
      ModalPedidoComponent,
      StateComponent,
      ToastrComponent,
      UploadFileComponent,
      AddFilesComponent,
      SingleoptionSinBindingComponent,
      MultioptionComponent,
      GuiaComponent,
      SolicitudinformacionComponent,
      FormCargadoComponent
  ],
    providers: [ FormService, FilesService ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts